import styled from 'styled-components'
import { SvgIcon } from 'components'
import DarkIcon from 'assets/menu-icons/toggle-dark.svg?react'
import LightIcon from 'assets/menu-icons/toggle-light.svg?react'

export const SocialMenuCenterWrapper = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  border-radius: 50%;
  transition: 0.4s all;
  &:hover {
    background-color: ${({ theme }) => theme.nestedMenuHover};
  }
  &:active {
    opacity: 0.7;
    background-color: ${({ theme }) => theme.nestedMenuHover};
  }
`

export const IconWrapper = styled(SvgIcon)`
  height: 24px;
  width: 24px;
  cursor: pointer;
  transition: 0.3s;
`

export const LightModeIcon = styled(LightIcon)`
  width: 24px;
  height: 24px;
`

export const DarkModeIcon = styled(DarkIcon)`
  width: 24px;
  height: 24px;
`
